import { render, staticRenderFns } from "./BudgetStatsSection.vue?vue&type=template&id=7f74cdf0&"
import script from "./BudgetStatsSection.vue?vue&type=script&lang=js&"
export * from "./BudgetStatsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports